
import { defineComponent, PropType } from 'vue'
import { Maybe, PackageGroup, RepositoryPackage, VulnerabilitySeverity } from '~/types/types'

import { severityIconMap } from '~/utils/dependencies'

export default defineComponent({
  name: 'PackageListItem',
  components: {},
  data() {
    return {
      severityIconMap
    }
  },
  computed: {
    VulnerabilitySeverity() {
      return VulnerabilitySeverity
    },
    packageQuery() {
      return `package:${this.pkg.package.name}@${this.pkg.packageVersion.version}`
    },
    packageGroupLabel() {
      if (this.pkg.packageGroup) {
        switch (this.pkg.packageGroup) {
          case PackageGroup.Dev:
            return 'DEVELOPMENT'
          case PackageGroup.Prod:
            return 'PRODUCTION'
          case PackageGroup.Test:
            return 'TESTING'
          case PackageGroup.Documentation:
            return 'DOCUMENTATION'
          default:
            return ''
        }
      }
      return ''
    },
    packageGroupColor() {
      if (this.pkg.packageGroup) {
        switch (this.pkg.packageGroup) {
          case PackageGroup.Prod:
            return 'aqua'
          default:
            return 'vanilla'
        }
      }
      return 'vanilla'
    },
    licenses() {
      if (!this.pkg.packageVersion.licenses || !this.pkg.packageVersion.licenses.edges) {
        return []
      }

      const processedLicenses = this.pkg.packageVersion.licenses.edges.reduce((acc, edge) => {
        if (edge?.node) {
          const identifier =
            edge.node.identifier.length > 20
              ? edge.node.identifier.slice(0, 20) + '...'
              : edge.node.identifier
          acc.push({
            identifier,
            name: edge.node.name,
            isSafe: edge.node.isSafe
          })
        }
        return acc
      }, [] as { identifier: string; name: string; isSafe: Maybe<boolean> | undefined }[])

      return processedLicenses
        .sort((a, b) => {
          const isASafe = a.isSafe === true
          const isBSafe = b.isSafe === true
          if (isASafe === isBSafe) {
            return 0
          }
          return isASafe ? -1 : 1
        })
        .slice(0, 2)
    }
  },
  props: {
    pkg: {
      type: Object as PropType<RepositoryPackage>,
      required: true
    }
  },
  methods: {
    getLicenseColor(isSafe: Maybe<boolean> | undefined): string {
      if (isSafe === null || typeof isSafe === 'undefined') {
        return 'vanilla'
      }
      return isSafe ? 'juniper' : 'cherry'
    }
  }
})
